import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tooteid ei leitud

  <span style="color:#85c1dc;">**FI:**</span>
  Tuotteita ei löytynyt

  <span style="color:#85c1dc;">**RU:**</span>
  Товары не найдены
*/
/* @__NO_SIDE_EFFECTS__ */
const m861 = msg(
  mf`Tooteid ei leitud`,
  mf`Tuotteita ei löytynyt`,
  mf`Товары не найдены`,
)

export { m861 as 'w.module.no-results.hall.title' }